import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
  }

  initialize() {
    this.apply()
  }

  apply() {
    document.documentElement.setAttribute("data-theme", this.theme)
    const path = this.urlValue
    if (path) {
      fetch(path, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({theme: this.theme}),
      })
    }
  }

  switch(event) {
    this.theme = event.target.dataset.themeValue || event.target.closest("[data-theme-value]")?.dataset.themeValue
    this.apply()
  }

  get systemDefault() {
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"
  }

  get theme() {
    return window.localStorage.getItem("theme") || (this.theme = this.systemDefault)
  }

  set theme(value) {
    window.localStorage.setItem("theme", value)
  }
}
